import ajax from "./ajax";

export function getMenu() {
  return ajax(`/menus?sort=display_order&per-page=1000`);
}
